var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"t-page"},[_c('section',{staticClass:"t-page__heading"},[_c('h1',{staticClass:"t-page__title",class:{
        't-page__title_hidden': _vm.hideTitle,
        't-page__title_caps': _vm.capitalizeTitle
      }},[_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")])]),_vm._v(" "),_c('section',{staticClass:"t-page__content"},[_c('ContentfulDocument',{attrs:{"document":_vm.content}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }